import React, { useState } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Backdrop from "../../Backdrop";
import { BlurOther } from "../../Blur";
import Columns from "../../Columns";
import Image from "../../Image";
import { MarkdownInline } from "../../Markdown";
import ModalPortal from "../../Modal/Portal";
import Button from "../../NewForms/Button";
import Headline from "../../NewHeadline";
import InfoIcon from "./InfoIcon";

const Container = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}

        color: ${theme.colors.blue.toString()};
    `}
`;

const RightCenterContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        justify-content: center;
    `}
`;

const RightContentContainer = styled.div`
    display: flex;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        display: inline-flex;
        margin: 0 auto;
    `}

    flex-direction: column;
`;

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100%;
    height: 100%;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
`;

const ModalContentContainer = styled.div`
    padding: 20px;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        padding: 40px;
    `}

    z-index: 23;
    background-color: white;
    border-radius: 10px;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    ${({ theme }) => theme.breakpoints.from.large.css`
        margin-top: 150px;
    `}

    overflow: auto;
    max-height: 80vh;
`;

const List = styled.ol`
    margin-left: 20px;
    ${({ theme }) => theme.breakpoints.from.large.css`
        margin-left: 0;
    `}

    font-weight: 500;
`;

const ListItemContent = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
`;

const qrCodeStyles = css`
    width: 100%;
    max-width: 200px;
    height: auto;
    max-height: 200px;
`;

const QrCodeWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const CloseButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

const iconStyles = css`
    width: 16px;
    height: 16px;
    cursor: pointer;
`;

const buttonStyles = css`
    margin-top: 20px;
`;

const ThgColumns = ({ leftColumn, rightColumn }) => {
    const [infoText, setInfoText] = useState(undefined);
    const [qrCode, setQrCode] = useState(undefined);

    const handleClose = () => {
        setInfoText(undefined);
        setQrCode(undefined);
    };

    return (
        <>
            <Container>
                <Columns>
                    <Columns.Column>
                        <Headline>{leftColumn.headline}</Headline>
                        <MarkdownInline>{leftColumn.text}</MarkdownInline>
                    </Columns.Column>
                    <Columns.Column>
                        <RightCenterContainer>
                            <RightContentContainer>
                                <Headline>{rightColumn.headline}</Headline>
                                <List>
                                    {rightColumn.items.map((item, index) => (
                                        <li key={index}>
                                            <ListItemContent>
                                                {item.name}{" "}
                                                {item.infoText && (
                                                    <>
                                                        <InfoIcon
                                                            onClick={() => {
                                                                setInfoText(
                                                                    item.infoText
                                                                );
                                                                setQrCode(
                                                                    item.image
                                                                );
                                                            }}
                                                            css={iconStyles}
                                                        />
                                                    </>
                                                )}
                                            </ListItemContent>
                                        </li>
                                    ))}
                                </List>
                                <Button
                                    to={rightColumn.buttonLink}
                                    css={buttonStyles}
                                >
                                    {rightColumn.buttonCaption}
                                </Button>
                            </RightContentContainer>
                        </RightCenterContainer>
                    </Columns.Column>
                </Columns>
            </Container>
            {infoText && (
                <>
                    <BlurOther blur={["Page"]} />
                    <ModalPortal>
                        <Backdrop
                            open={infoText !== undefined}
                            className="backdrop"
                        >
                            <ModalContainer className="backdrop">
                                <ModalContentContainer>
                                    <MarkdownInline>{infoText}</MarkdownInline>
                                    {qrCode?.src && (
                                        <QrCodeWrapper>
                                            <Image
                                                css={qrCodeStyles}
                                                {...qrCode}
                                            />
                                        </QrCodeWrapper>
                                    )}
                                    <CloseButtonWrapper>
                                        <Button
                                            color="blueOutline"
                                            onClick={handleClose}
                                        >
                                            Schließen
                                        </Button>
                                    </CloseButtonWrapper>
                                </ModalContentContainer>
                            </ModalContainer>
                        </Backdrop>
                    </ModalPortal>
                </>
            )}
        </>
    );
};

export default ThgColumns;
